export const environment = {
  production: false,
  grafana: {
    url: 'https://faro-collector-prod-us-east-2.grafana.net/collect/9142a2faf2025e2af0e267bc5aa41d88',
    appName: 'Dev Panorama',
    env: 'development',
  },
  aws: {
    // Feature flags proxy GitLab's Unleash API, mapping its `features` shape to
    // the `toggles` shape unleash-proxy-client expects. It shares the secure
    // proxy's API and conventions (secret in Secrets Manager, upstream URL in
    // Parameter Store), but its route is deliberately unauthenticated: the
    // client starts at app bootstrap, before a Ping token exists, and it calls
    // with its own fetch so the ping-auth interceptor never sees it.
    // Same-origin like the rest: the CloudFront /api/v1/flags behavior shares the
    // gateway origin and the api-v1-uri-rewrite function. Deliberate — this is
    // the one endpoint CORS has broken twice, and same-origin removes the
    // mechanism entirely rather than patching an allowlist.
    featureFlagEndpoint: 'https://dev-informatics.roche.com/api/v1/flags',
    featureFlagAppName: 'dev',
    // Secure proxy (API Gateway → Lambda → SSM). Backend secret injected
    // server-side; the SPA sends only the user's Ping bearer token.
    // Served same-origin under the SPA's own Cloudflare-fronted domain
    // (dev-informatics.roche.com) via CloudFront /api/v1/* behaviors → API GW.
    // Same origin = zero CORS; the Cloudflare hop satisfies the org WAF
    // (rcp_waf_cloudflare_protected), unlike a direct execute-api call.
    mulesoftEndpoint: 'https://dev-informatics.roche.com/api/v1/mulesoft',
    fulfillmentEndpoint: 'https://dev-informatics.roche.com/api/v1/fulfillment',
    sinequaEndpoint: 'https://dev-informatics.roche.com/api/v1/sinequa',
    // Assistant streams SSE, so it is served from the SPA's own CloudFront
    // distribution under /api/v1/* → a Lambda Function URL (RESPONSE_STREAM)
    // fronted by OAC. Same origin as the SPA (zero CORS) and Cloudflare-fronted,
    // so the org WAF passes. OAC SigV4-signs the IAM origin; the Ping bearer
    // rides in X-Ping-Authorization (see ping-auth.interceptor).
    assistantEndpoint: 'https://dev-informatics.roche.com/api/v1/assistant',
  },
  gTag: 'G-EK2J8DXHYM',
  pingAuthInit: true,
  pingAuthMock: {},
  ping: {
    authority: 'https://wamqa.roche.com',
    clientId: 'panorama-dev',
    redirectUrl: 'https://dev-informatics.roche.com/',
    scope: 'openid profile email groups',
  },
  moderatorGroup: 'Panorama_Moderators-Dev',
};
